import { ERROR_CODES } from '@/consts';

export default class CannotBeBeforeClosureDate extends Error {
  static code = ERROR_CODES.CASH_LOG_CANNOT_BE_BEFORE_CLOSURE_DATE;

  constructor(message) {
    super(message || 'Invalid Date.');
    this.code = ERROR_CODES.CASH_LOG_CANNOT_BE_BEFORE_CLOSURE_DATE;
  }
}
